"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsChangeLog = void 0;
const date_fns_1 = require("date-fns");
const tracking_1 = require("@/services/tracking");
const tracking_2 = require("@/store/ducks/tracking");
function getComponentsChangeLog(pageIndex, pageSize) {
    return (dispatch) => {
        dispatch((0, tracking_2.getTrackingData)());
        (0, tracking_1.getChangeLog)(pageIndex, pageSize, {
            name: "affectedTable",
            value: "Components",
            sort: "createdAt"
        })
            .then((response) => {
            if (response.length === 0) {
                dispatch((0, tracking_2.setHasEndingTrackingData)());
            }
            const changelog = response.map((componentChanges) => {
                return buildComponentsChangelog(componentChanges);
            });
            dispatch((0, tracking_2.getTrackingDataSuccess)(changelog));
        })
            .catch(() => {
            dispatch((0, tracking_2.getTrackingError)());
        });
    };
}
exports.getComponentsChangeLog = getComponentsChangeLog;
const buildComponentsChangelog = (componentChange) => {
    const unparsedLogDate = new Date(getChangelogDate(componentChange.data));
    const logDate = (0, date_fns_1.format)(new Date(unparsedLogDate), "dd MMM y | H:mm:ss");
    return {
        operationTitle: defineOperationTitle(componentChange.operation),
        affectedEntityName: getAffectedEntityName(componentChange.data),
        logDate,
        user: componentChange.userId,
        operation: componentChange.operation,
        logCreationDate: componentChange.createdAt,
    };
};
const defineOperationTitle = (operation) => {
    switch (operation) {
        case "UPDATE":
            return "Component changed";
        case "CREATE":
            return "Added new component";
        case "DELETE":
            return "Component deleted";
        default:
            return "Operation not detected";
    }
};
const getAffectedEntityName = (data) => {
    try {
        if (data) {
            const parsedData = JSON.parse(data);
            return parsedData.name;
        }
    }
    catch (e) {
        throw new Error(`[Products Changelog Error: Error while getting affected entity name - ${e}]`);
    }
};
const getChangelogDate = (data) => {
    try {
        if (data) {
            const parsedData = JSON.parse(data);
            const date = parsedData.operation === "DELETE"
                ? parsedData.deletedAt
                : parsedData.updatedAt;
            return date;
        }
    }
    catch (e) {
        throw new Error(`[Components Changelog Error: Error while getting log date - ${e}]`);
    }
};
